import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatBoxService {
    private openChatBoxSubject = new Subject<void>();
    openChatBox$ = this.openChatBoxSubject.asObservable();

    open(): void {
        this.openChatBoxSubject.next();
    }
}
